import React from 'react'

// inputs
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline';
import AppFormikTextareaInline from 'utlis/helpers/forms/AppFormikTextareaInline';

// html editor
import HTMLEditor from 'utlis/helpers/HTMLEditor'

export default function FormContent(props) {
    const { 
        formik,
        getResult
    } = props

    return (
        <>
            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Link"} // label name
                // isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Link"} // placeholder for the input
                formikFieldName={"link"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikTextareaInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap"} // class name for main wrapper
                labelName={"Caption"} // label name
                placeholder={"Caption"} // placeholder for the input
                textareaRows={"4"} // rows for textarea
                formikFieldName={"caption"} // important: formik value name for the input
            />
            {/* <div className={`st-form st-form-with-label-left d-flex flex-wrap mb-3 mb-lg-4 ${(formik.touched.content && formik.errors.content) ? "has-msg msg-error" : ""}`} style={{paddingRight: 15}}>
                <label>
                    Content
                </label>
                <div className="media-body">
                    <HTMLEditor
                        defaultValue={formik.values.content}
                        getResult={getResult}
                    /> */}

                    {
                        /* form message */
                        // (formik.touched.content && formik.errors.content) && (
                        //     <div className="st-form-msg position-absolute" style={{ bottom: -18 }}>
                        //         <p className="st-fs-12">{formik.errors.content}</p>
                        //     </div>
                        // )
                    }
                {/* </div>
            </div> */}
        </>
    )
}
